/* Ari's artwork, shared by the landing-page emblem and the in-app orb so the
   two never drift apart. */
export const ARI_GLASS =
  'https://static.prod-images.emergentagent.com/jobs/40cc5c7f-c45c-491d-ad3f-cc7864e78796/images/af1f8ad9f6e23da84bf0de9611ed9af7f95c7d2ba33cc94ad1daf6fa09a1d119.jpeg';

export const ARI_BOLT =
  'https://static.prod-images.emergentagent.com/jobs/40cc5c7f-c45c-491d-ad3f-cc7864e78796/images/ff096f02e22940a350274cabc64bcc1ed645d1714acb76c14643060155edec1a.jpeg';

export const ARI_AVATAR =
  'https://static.prod-images.emergentagent.com/jobs/40cc5c7f-c45c-491d-ad3f-cc7864e78796/images/4063fc24bf32f027848a8288e2bda515ed9b161b95609e2e01d5ded18984e549.jpeg';
